<template>
  <!-- Routes the active OnBoardingPage in the page stack to the appropriate
       component. Used by both the modal (OnBoarding.vue) and the standalone
       /login page (LoginApp.vue) so the two share one design language and
       one source of behaviour. -->
  <div>
    <OnBoardingLoginPage v-if="topPageIsLogin" />
    <OnBoardingSignUpPage v-if="topPageIsSignUp" />
    <OnBoardingDownloadGPXPage v-if="topPageIsDownloadGPX" />
    <OnBoardingConfirmDetailsPage v-if="topPageIsConfirmDetails" />
    <OnBoardingEmailSignUpDetailsPage v-if="topPageIsEmailSignUp" />
    <OnBoardingVerifyEmailPage v-if="topPageIsVerifyEmailSent" />
    <OnBoardingEmailLoginPage v-if="topPageIsEmailLogin" />
    <OnBoardingMagicLinkPage v-if="topPageIsMagicLink" />
    <OnBoardingProfileNamePage v-if="topPageIsProfileName" />
    <OnBoardingProfileCountryPage v-if="topPageIsProfileCountry" />
    <OnBoardingProfileUsernamePage v-if="topPageIsProfileUsername" />
    <OnBoardingProfilePhotoPage v-if="topPageIsProfilePhoto" />
    <OnBoardingProfileSettingsPage v-if="topPageIsProfileSettings" />
    <OnBoardingProfileSourcePage v-if="topPageIsProfileSource" />
    <OnBoardingProfileComingFromPage v-if="topPageIsProfileComingFrom" />
    <OnBoardingSuccessPage v-if="topPageIsSuccess" />
    <OnBoardingAddToListPage v-if="topPageIsAddTrailToList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { OnBoardingPage } from '../../../utils/models/OnBoardingPage';
import OnBoardingAddToListPage from './OnBoardingAddToListPage.vue';
import OnBoardingConfirmDetailsPage from './OnBoardingConfirmDetailsPage.vue';
import OnBoardingDownloadGPXPage from './OnBoardingDownloadGPXPage.vue';
import OnBoardingEmailLoginPage from './OnBoardingEmailLoginPage.vue';
import OnBoardingEmailSignUpDetailsPage from './OnBoardingEmailSignUpDetailsPage.vue';
import OnBoardingVerifyEmailPage from './OnBoardingVerifyEmailPage.vue';
import OnBoardingLoginPage from './OnBoardingLoginPage.vue';
import OnBoardingMagicLinkPage from './OnBoardingMagicLinkPage.vue';
import OnBoardingProfileComingFromPage from './OnBoardingProfileComingFromPage.vue';
import OnBoardingProfileCountryPage from './OnBoardingProfileCountryPage.vue';
import OnBoardingProfileNamePage from './OnBoardingProfileNamePage.vue';
import OnBoardingProfilePhotoPage from './OnBoardingProfilePhotoPage.vue';
import OnBoardingProfileSettingsPage from './OnBoardingProfileSettingsPage.vue';
import OnBoardingProfileSourcePage from './OnBoardingProfileSourcePage.vue';
import OnBoardingProfileUsernamePage from './OnBoardingProfileUsernamePage.vue';
import OnBoardingSignUpPage from './OnBoardingSignUpPage.vue';
import OnBoardingSuccessPage from './OnBoardingSuccessPage.vue';

export default defineComponent({
  name: 'OnBoardingPageRouter',
  components: {
    OnBoardingLoginPage,
    OnBoardingSignUpPage,
    OnBoardingProfileNamePage,
    OnBoardingProfileCountryPage,
    OnBoardingProfileUsernamePage,
    OnBoardingProfilePhotoPage,
    OnBoardingProfileSettingsPage,
    OnBoardingProfileSourcePage,
    OnBoardingProfileComingFromPage,
    OnBoardingDownloadGPXPage,
    OnBoardingConfirmDetailsPage,
    OnBoardingEmailSignUpDetailsPage,
    OnBoardingVerifyEmailPage,
    OnBoardingEmailLoginPage,
    OnBoardingMagicLinkPage,
    OnBoardingSuccessPage,
    OnBoardingAddToListPage,
  },
  computed: {
    topPage() {
      return this.$store.getters['onBoarding/lastPage'];
    },
    topPageIsAddTrailToList(): boolean {
      return this.topPage === OnBoardingPage.AddTrailToList;
    },
    topPageIsSuccess(): boolean {
      return this.topPage === OnBoardingPage.Success;
    },
    topPageIsProfileName(): boolean {
      return this.topPage === OnBoardingPage.ProfileName;
    },
    topPageIsProfileCountry(): boolean {
      return this.topPage === OnBoardingPage.ProfileCountry;
    },
    topPageIsProfileUsername(): boolean {
      return this.topPage === OnBoardingPage.ProfileUsername;
    },
    topPageIsProfilePhoto(): boolean {
      return this.topPage === OnBoardingPage.ProfilePhoto;
    },
    topPageIsProfileSettings(): boolean {
      return this.topPage === OnBoardingPage.ProfileSettings;
    },
    topPageIsProfileSource(): boolean {
      return this.topPage === OnBoardingPage.ProfileSource;
    },
    topPageIsProfileComingFrom(): boolean {
      return this.topPage === OnBoardingPage.ProfileComingFrom;
    },
    topPageIsEmailSignUp(): boolean {
      return this.topPage === OnBoardingPage.EmailSignUp;
    },
    topPageIsVerifyEmailSent(): boolean {
      return this.topPage === OnBoardingPage.VerifyEmailSent;
    },
    topPageIsEmailLogin(): boolean {
      return this.topPage === OnBoardingPage.EmailLogin;
    },
    topPageIsMagicLink(): boolean {
      return this.topPage === OnBoardingPage.MagicLink;
    },
    topPageIsLogin(): boolean {
      return this.topPage === OnBoardingPage.LoginOptions;
    },
    topPageIsSignUp(): boolean {
      return this.topPage === OnBoardingPage.SignUpOptions;
    },
    topPageIsDownloadGPX(): boolean {
      return this.topPage === OnBoardingPage.DownloadGPX;
    },
    topPageIsConfirmDetails(): boolean {
      return this.topPage === OnBoardingPage.ConfirmDetails;
    },
  },
});
</script>
